/**
 * GlobalDataView
 *
 * Full-page body for the super-admin-managed Global Data area — reusable game
 * data that is independent of any single game instance. Rendered as an overlay
 * from DashboardLayout (like ContentLibrary); the Back / title / user-menu
 * header lives in DashboardLayout.
 *
 * The shell is generic: it renders one tab per registered module (see
 * ./registry). Cartel Items is the only module today; it is being replaced by
 * platform item data (PLATFORM_INTEGRATION.md, Phase 2). SW:TOR locations
 * already come from the platform.
 */

import { useState } from 'react';
import { type Tab } from '@swtorbit/shared-components';
import { Tabs } from '@swtorbit/ui/react';
import { GLOBAL_DATA_TABS } from './registry';

const TABS: Tab[] = GLOBAL_DATA_TABS.map((t) => ({ id: t.id, label: t.label, content: null }));

export function GlobalDataView() {
  const [activeTab, setActiveTab] = useState<string>(GLOBAL_DATA_TABS[0]?.id ?? '');

  const renderTabContent = () => {
    const tab = GLOBAL_DATA_TABS.find((t) => t.id === activeTab);
    if (!tab) return null;
    const Body = tab.Component;
    return <Body />;
  };

  return (
    <div className="d-flex flex-column flex-1">
      <Tabs center items={TABS.map((t) => ({ value: t.id, label: t.label }))} value={activeTab} onChange={setActiveTab}>{renderTabContent()}</Tabs>
    </div>
  );
}
